import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const PromotionDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Promotion management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default PromotionDetailHeader;
